export default __webpack_public_path__ + "5f3997436009d4d0c6cd912c0bb06508.svg";